import styled from 'styled-components';

export const ErrorSC = styled.div`
  display: flex;
  justify-content: flex-end;
  line-height: 2em;
  font-weight: 450;
  i {
    font-size: 18px;
    color: #bd0505;
    margin-right: 12px;
    margin-top: 2px;
  }
`;

export const ErrorMsg = styled.div`
  background: #bd0505;
  border-radius: 4px 0 0 2px;
  padding: 6px 16px;
  p {
    color: white;
  }
  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;
